export const OPENED_MODAL_EVENT = 'Opened Modal';
export const CLOSED_MODAL_EVENT = 'Closed Modal';
